import { useParams } from "react-router";

export function useStrictParams<T extends Record<string, string>>() {
  const params = useParams<T>();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) {
      throw new Error(`Missing route param: ${key}`);
    }
  }

  return params as unknown as { [K in keyof T]: string };
}
